<template>
  <div class="confirmation-summary-contact-row">
    <span>{{fullName}}</span>
    <span>{{contact.primaryEmail}}</span>
    <span v-if="phoneNumberDisplay">
      <a :href="`tel:${phoneNumberDisplay}`">{{phoneNumberDisplay}}</a>
    </span>
  </div>
</template>

<script>

export default {
  props: {
    contact: {
      type: Object,
      required: true,
    },
  },
  computed: {
    fullName() {
      const nameParts = [];
      const { familyName, givenName } = this.contact;
      if (givenName) {
        nameParts.push(givenName);
      }
      if (familyName) {
        nameParts.push(familyName);
      }

      return nameParts.join(' ');
    },
    phoneNumberDisplay() {
      const { homePhone, mobilePhone, workPhone } = this.contact;
      return mobilePhone || homePhone || workPhone || '';
    },
  },
};
</script>

<style lang="scss" scoped>
.confirmation-summary-contact-row {
  span {
    display: block;
  }
}
</style>
